import {ElementRef, Injectable} from '@angular/core';
import {LoaderService} from './loader.service';
import {PdfPaginationOptions, printPdfDoc, renderElementToPdf, savePdfDoc} from './pdf-pagination';

// The one place in the app that turns a printable element into a PDF. Every Print / Download / Add to Chart
// button (Super Bill, invoices, intake form reports, vitals, enotes, rich text templates, health calendar &
// review reports) goes through here so the page-margin and no-mid-row-cut fix in pdf-pagination.ts only has to
// exist once.
@Injectable({
  providedIn: 'root'
})
export class PrintService {

  constructor(public loaderService: LoaderService) { }

  // Existing signature, unchanged, so current callers (health calendar report, review report) keep working as-is.
  generatePdf(action: string, view: ElementRef, addFooter: boolean, file_name?: string, options?: PdfPaginationOptions) {
    this.loaderService.show();
    this.renderToPdf(view.nativeElement, options).then(doc => {
      if (addFooter) {
        this.addFooter(doc);
      }
      this.finish(action, doc, file_name);
      this.loaderService.hide();
    });
  }

  // For callers that need the jsPDF document itself rather than an immediate print/save, e.g. to read it back
  // out as a Blob for upload (Add to Chart) or to attach to a message (Send Superbill).
  renderToPdf(element: HTMLElement, options?: PdfPaginationOptions): Promise<any> {
    return renderElementToPdf(element, options);
  }

  finish(action: string, doc: any, file_name?: string) {
    if (action === 'print') {
      printPdfDoc(doc);
    } else {
      savePdfDoc(doc, file_name);
    }
  }

  addFooter(doc) {
    // const pageCount = doc.internal.getNumberOfPages();
    // let currentTime = new Date()
    // for (var i = 1; i <= pageCount; i++) {
    //   doc.setPage(i);
    //   doc.setFontSize(7);
    //   doc.text('' + currentTime.toLocaleString().split(',')[0], 4, 295, 'left')
    //   doc.text('Page ' + String(i) + ' of ' + String(pageCount), 205, 295, 'right');
    //   doc.text('www.wellwink.com ', 95, 295, 'justify');
    // }
  }
}
